<template>
    <div class="title">
        提醒您
    </div>
    <div class="content xs:max-w-[24rem]">
        <!-- <ol :class="{'list-inside list-decimal':result.isBothShow}">
            <li
                v-for="item in result.data"
                v-show="item.verifyResult === false"
                :key="item.id"
                class="text-black"
                :class="{'indent-1':result.isBothShow}"
            >
                您{{ item.mobileChange ? '變更後' : '留存於本公司' }}之行動電話非{{ item.id === 'applicant' ? '要保人' : '' }}{{ item.id === 'insured' ? '被保險人' : '' }}本人所申辦
            </li>
        </ol>
        <div class="mt-1.5">
            因該門號為日後與您進行聯絡或相關服務通知之重要資訊，故為維護您的權益，將會有電訪人員與您再次確認，謝謝。
        </div> -->
        <div v-if="result.type === 'B'">
            變更後之{{ result.target }}行動電話與門號登記人之關係非配偶及直系親屬，因行動電話為日後與您聯絡或相關服務通知之重要資訊，為維護您的權益，請變更為本人登記之門號，謝謝。
        </div>
        <div v-if="result.type === 'C'">
            留存於公司之要保人行動電話非為本人所申辦，因該門號為日後與您進行聯絡或相關服務通知之重要資訊，為維護您的權益，將會有電訪人員與您再次確認，謝謝。
        </div>
    </div>
    <div class="action justify-center">
        <button
            class="btn btn-error rounded-full mr-3 "
            @click.stop="$emit('goHome')"
        >
            取消變更
        </button>
        <button
            class="btn gradient-primary rounded-full"
            @click.stop="result.type=== 'B'? $emit('close') : $emit('goConfirm')"
        >
            確認
        </button>
    </div>
</template>

<script>
export default {
    props: {
        result: {
            type: Object,
            required: true
        }
    },
    emits: ['goHome', 'goConfirm', 'close'],
};
</script>
